import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../store/store";
import { QuickFilter, setQuickFilter } from "../store/slices/filters.slice";
import { cleanUpFeedPage } from "../store/slices/feed.slice";

const SORT_MAP: Record<QuickFilter, string> = {
  all: "popularity.desc",
  for_you: "popularity.desc",
  popular: "popularity.desc",
  top_rated: "vote_average.desc",
  new_releases: "release_date.desc",
};

const useFeed = () => {
  const dispatch = useAppDispatch();
  const quickFilter: QuickFilter = useAppSelector((state: any) => state.filters.quickFilter);

  const selectQuickFilter = useCallback(
    (filter: QuickFilter) => {
      if (filter === quickFilter) return;
      dispatch(setQuickFilter(filter));
      dispatch(cleanUpFeedPage());
    },
    [dispatch, quickFilter]
  );

  const onGenresApplied = useCallback(
    (genres: number[]) => {
      if (genres.length > 0 && (quickFilter === "all" || quickFilter === "for_you")) {
        dispatch(setQuickFilter("popular"));
      }
      if (genres.length === 0 && quickFilter !== "all") {
        dispatch(setQuickFilter("all"));
      }
    },
    [dispatch, quickFilter]
  );

  const sortBy = SORT_MAP[quickFilter];

  return { quickFilter, selectQuickFilter, onGenresApplied, sortBy };
};

export default useFeed;
